<template>
  <v-container fluid pa-0 fill-height>
    <v-row align="center" justify="center" class="fill-height" no-gutters>
      <v-col cols="auto">
        <v-row justify="center" class="pb-3">
          <v-progress-circular indeterminate width="1" size="40"></v-progress-circular>
        </v-row>
        <div class="title font-weight-thin mt-3"><slot></slot></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

  export default {
    components: {},
    name: "data-load",
    data: () => ({

    }),
    methods: {

    },
    mounted() {

    },
    beforeDestroy() {

    }
  }
</script>

<style scoped>

</style>
